import React from "react";

const GeralFormComponent = () => {
  return <div>GeralFormComponent</div>;
};

export default GeralFormComponent;
